import { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { usePageTitle } from "@/hooks/usePageTitle";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { LogIn } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function MemberLoginPage() {
  usePageTitle("Mitglied Login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const formRef = useRef(null);

  useEffect(() => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/members/login`, { email, password });
      localStorage.setItem("member_token", res.data.token);
      localStorage.setItem("member", JSON.stringify(res.data.member));
      toast.success(`Willkommen, ${res.data.member.name}!`);
      navigate("/mein-bereich");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login fehlgeschlagen");
    } finally { setLoading(false); }
  };

  return (
    <div className="py-12 md:py-0 md:min-h-screen flex items-center justify-center p-4">
      <div ref={formRef} className="max-w-md w-full bg-card border border-white/10 p-8">
        <div className="flex items-center gap-3 mb-6">
          <LogIn className="w-6 h-6 text-primary" />
          <h1 className="text-2xl font-bold uppercase tracking-tight" style={{ fontFamily: 'Oswald' }}>Mitglieder-Login</h1>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-sm">E-Mail</Label>
            <Input required type="email" value={email} onChange={e => setEmail(e.target.value)}
              className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="member-login-email" placeholder="max@beispiel.at" />
          </div>
          <div>
            <Label className="text-sm">Passwort</Label>
            <Input required type="password" value={password} onChange={e => setPassword(e.target.value)}
              className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="member-login-password" />
          </div>
          <div className="text-right">
            <Link to="/passwort-reset" className="text-xs text-muted-foreground hover:text-primary" data-testid="forgot-password-link">
              Passwort vergessen?
            </Link>
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-none font-bold uppercase" data-testid="member-login-submit">
            {loading ? "Wird geladen..." : "Einloggen"}
          </Button>
          <p className="text-center text-xs text-muted-foreground">
            Noch kein Mitglied? <Link to="/mitglied-registrieren" className="text-primary hover:underline">Jetzt registrieren</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
